import React from 'react';

function ImageUpload() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M24,21.3333333 L24,2.66666667 C24,1.20000012 22.8000004,0 21.3333333,0 L2.66666667,0 C1.20000012,0 0,1.20000012 0,2.66666667 L0,21.3333333 C0,22.8000004 1.20000012,24 2.66666667,24 L21.3333333,24 C22.8000004,24 24,22.8000004 24,21.3333333 Z M7.33333333,14 L10.6666667,18.0133336 L15.3333333,12 L21.3333333,20 L2.66666667,20 L7.33333333,14 Z"
        id="Fill-2"
      />
    </svg>
  );
  /* eslint-enable */
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/common/icons/ImageUpload.js